export const OrganizationApiUrls = {
  // JobLevel endpoints
  getAllJobLevels: "organization/joblevels",
  getJobLevelById: "organization/joblevels",
  createJobLevel: "organization/joblevels",
  updateJobLevel: "organization/joblevels",
  deleteJobLevel: "organization/joblevels",

  // JobGroup endpoints
  getAllJobGroups: "organization/jobgroups",
  getJobGroupById: "organization/jobgroups",
  createJobGroup: "organization/jobgroups",
  updateJobGroup: "organization/jobgroups",
  deleteJobGroup: "organization/jobgroups",

  // Department endpoints
  getAllDepartments: "organization/departments",
  getDepartmentById: "organization/departments",
  createDepartment: "organization/departments",
  updateDepartment: "organization/departments",
  deleteDepartment: "organization/departments",
};

export default class OrganizationAPI {
  constructor(httpsClient, cache) {
    this.httpsClient = httpsClient;
    this.cache = cache;
  }

  // JobLevel methods
  async getAllJobLevels(token) {
    return this.get(OrganizationApiUrls.getAllJobLevels, null, token);
  }

  async getJobLevelById(id, token) {
    return this.get(`${OrganizationApiUrls.getJobLevelById}/${id}`, null, token);
  }

  async createJobLevel(data, token) {
    return this.post(OrganizationApiUrls.createJobLevel, data, token, true, true);
  }

  async updateJobLevel(data, token) {
    return this.put(OrganizationApiUrls.updateJobLevel, data, token, true, true);
  }

  async deleteJobLevel(id, token) {
    return this.delete(`${OrganizationApiUrls.deleteJobLevel}/${id}`, null, token, true, true);
  }

  // JobGroup methods
  async getAllJobGroups(token) {
    return this.get(OrganizationApiUrls.getAllJobGroups, null, token);
  }

  async getJobGroupById(id, token) {
    return this.get(`${OrganizationApiUrls.getJobGroupById}/${id}`, null, token);
  }

  async createJobGroup(data, token) {
    return this.post(OrganizationApiUrls.createJobGroup, data, token, true, true);
  }

  async updateJobGroup(data, token) {
    return this.put(OrganizationApiUrls.updateJobGroup, data, token, true, true);
  }

  async deleteJobGroup(id, token) {
    return this.delete(`${OrganizationApiUrls.deleteJobGroup}/${id}`, null, token, true, true);
  }

  // Department methods
  async getAllDepartments(token) {
    return this.get(OrganizationApiUrls.getAllDepartments, null, token);
  }

  async getDepartmentById(id, token) {
    return this.get(`${OrganizationApiUrls.getDepartmentById}/${id}`, null, token);
  }

  async createDepartment(data, token) {
    return this.post(OrganizationApiUrls.createDepartment, data, token, true, true);
  }

  async updateDepartment(data, token) {
    return this.put(OrganizationApiUrls.updateDepartment, data, token, true, true);
  }

  async deleteDepartment(id, token) {
    return this.delete(`${OrganizationApiUrls.deleteDepartment}/${id}`, null, token, true, true);
  }

  // HTTP helper methods
  async get(url, data, token, eAlert, sAlert) {
    const response = await this.httpsClient.get(url, data, token, eAlert, sAlert);
    return response;
  }

  async post(url, data, token, eAlert, sAlert) {
    this.cache.remove("organization");
    return await this.httpsClient.post(url, data, token, eAlert, sAlert);
  }

  async put(url, data, token, eAlert, sAlert) {
    this.cache.remove("organization");
    return await this.httpsClient.put(url, data, token, eAlert, sAlert);
  }

  async delete(url, data, token, eAlert, sAlert) {
    this.cache.remove("organization");
    return await this.httpsClient.delete(url, data, token, eAlert, sAlert);
  }
}
